import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import '../../webcss/invoice.css';
import {
    POST_FUND_TRANSFER_INVOICE
} from '../../Utils/appConstants';
import { getUTCToLocalDateTimeFormat } from '../../Utils/function';
import { postRequest } from '../../Utils/AppApi';

const fundTransferStatus = (txtStatus) => {
    const statusMap = {
        '0': 'Success',
        '1': 'Failed',
        '2': 'Processing',
        '4': 'Refunded',
        '3': 'Pending',
    };
    return statusMap[txtStatus] || txtStatus || 'Processing';
};


 const getFinalStatus = (finalStatus) => {
        const statusMap = {
            'submitted': 'Submitted',
            'in_process': 'In Process',
            'sent_to_bank': 'Sent to Bank',
            'pending_at_bank': 'Pending at Bank',
            'success': 'Success',
            'failed': 'Failed',
            'refunded': 'Refunded'
        };
        return statusMap[finalStatus] || finalStatus || 'Unknown';
    };

function FundTransferInvoice(props) {
    const history = useHistory();
    const [idata, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [isPrintButton, setPrintButton] = useState(true);
    const { isPageView = false, transactionId } = props;

    const print = () => {
        setPrintButton(false);
        setTimeout(() => {
            window.print();
            setPrintButton(true);
        }, 100);
    };

    const handleInvoice = () => {
        if (!transactionId) return;
        setLoading(true);
        postRequest(POST_FUND_TRANSFER_INVOICE, { transactionId }, history)
            .then((response) => {
                if (response.success) setData(response.data || {});
                else setData({});
            })
            .catch(() => setData({}))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (transactionId) handleInvoice();
    }, [transactionId]);

    if (loading) {
        return (
            <div className="compact-loading-invoice">
                <div className="compact-spinner-invoice"></div>
                <p>Loading receipt details...</p>
            </div>
        );
    }

    const {
        customerMobile,
        amount,
        beneficiaryName,
        bankName,
        accountNumber,
        ifscCode,
        paymentMode,
        bank_ref_num,
        transactionId: txnId,
        txtStatus,
        finalStatus,
        createdAt,
        updatedAt
    } = idata;

    return (
        <div style={{
            maxWidth: '820px',
            margin: '0 auto',
            padding: '24px 28px',
            fontFamily: 'Arial, sans-serif',
            background: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        }}>

            {/* ===== HEADER – Mobile & Date ===== */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '2px solid #e9ecef',
                paddingBottom: '16px',
                marginBottom: '24px',
            }}>
                <img src="../logo.png" alt="Logo" style={{ height: '40px' }} />
                <div style={{ textAlign: 'right', fontSize: '16px', color: '#495057' }}>
                    <div><strong>Mobile:</strong> {customerMobile || 'N/A'}</div>
                    <div style={{ fontSize: '14px', marginTop: '4px', color: '#6c757d' }}>
                     {getUTCToLocalDateTimeFormat(createdAt)}
                    </div>
                </div>
            </div>

            {/* ===== BENEFICIARY DETAILS ===== */}
            <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                    margin: '0 0 12px 0',
                    fontSize: '16px',
                    color: '#212529',
                    fontWeight: '600',
                    letterSpacing: '0.3px'
                }}>
                    <i className="fa fa-user-circle" style={{ marginRight: '8px' }}></i>
                    Beneficiary Details
                </h4>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '10px 30px',
                    background: '#f8f9fa',
                    padding: '16px 20px',
                    borderRadius: '8px',
                    fontSize: '15px',
                    border: '1px solid #e9ecef'
                }}>
                    <div><strong>Name:</strong> {beneficiaryName || 'N/A'}</div>
                    <div><strong>Bank:</strong> {bankName || 'N/A'}</div>
                    <div><strong>Account:</strong> {accountNumber || 'N/A'}</div>
                    <div><strong>IFSC:</strong> {ifscCode || 'N/A'}</div>
                </div>
            </div>

            {/* ===== TRANSACTION DETAILS TABLE ===== */}
            <div style={{ marginBottom: '24px' }}>
                <div style={{
                    border: '1px solid #e9ecef',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    background: '#ffffff'
                }}>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '14px',
                    }}>
                        <thead style={{ background: '#f1f3f5' }}>
                            <tr>
                                <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Date & Time</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Txn ID</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Mode</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>UTR/RRN</th>
                                <th style={{ padding: '12px 16px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>Amount</th>
                                <th style={{ padding: '12px 16px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ borderBottom: '1px solid #f1f3f5' }}>
                                <td style={{ padding: '12px 16px', color: '#495057' }}>{getUTCToLocalDateTimeFormat(updatedAt)}</td>
                                <td style={{ padding: '12px 16px', color: '#495057' }}>{txnId}</td>
                                <td style={{ padding: '12px 16px', color: '#495057' }}>{paymentMode || 'N/A'}</td>
                                <td style={{ padding: '12px 16px', color: '#495057' }}>{bank_ref_num || '-'}</td>
                                <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#212529' }}>₹{amount || 0}</td>
                                <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                    <span style={{
                                        padding: '4px 14px',
                                        borderRadius: '20px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#fff',
                                        backgroundColor: txtStatus === '0' ? '#28a745' : txtStatus === '1' ? '#dc3545' : '#ffc107',
                                        display: 'inline-block'
                                    }}>
                                        {getFinalStatus(finalStatus)}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ===== FOOTER ===== */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderTop: '2px solid #e9ecef',
                paddingTop: '16px',
                marginTop: '8px',
                fontSize: '13px',
                color: '#868e96'
            }}>
                <span>
                    <i className="fa fa-info-circle" style={{ marginRight: '6px' }}></i>
                    Computer generated receipt – No signature required
                </span>
                {isPageView && isPrintButton && (
                    <button onClick={print} style={{
                        padding: '6px 20px',
                        fontSize: '14px',
                        fontWeight: '500',
                        background: '#007bff',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 6px rgba(0,123,255,0.3)',
                        transition: 'background 0.15s'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#0069d9'}
                    onMouseLeave={(e) => e.target.style.background = '#007bff'}
                    >
                        <i className="fa fa-print" style={{ marginRight: '6px' }}></i>
                        Print
                    </button>
                )}
            </div>
        </div>
    );
}

export default FundTransferInvoice;